import React, { Component } from "react";
import ModalCloseButton from "../Common/Modal/ModalCloseButton";
import { DragModal, TTPModal } from "../Common/Modal/TTPModal";
import styles from "./PeriodFinancialSheet.local.scss";
import { Button, Select } from "antd";
import { connect } from "react-redux";
import {
  setImportFinancialModal,
  setImportAttachment,
  setImportedYear
} from "Actions";
import _ from "i18n";
import { YEARS_VALUES } from "Config";
import DocumentUploader from "../Common/DocumentUploader/DocumentUploader";
import { ICONS, SvgIcon } from "../Common/Icons";
import { importFinancialSheet, fetchPeriodFinancialSheet } from "Thunks";
import { onSuccess, onError } from "Utils";

const { Option } = Select;

class ImportFinancialModal extends Component {
  handleCancelImportFinancial = () => {
    const { dispatch } = this.props;
    dispatch(setImportFinancialModal(false));
  };

  handleDrop = acceptedFiles => {
    if (acceptedFiles.length === 0) return;
    this.props.dispatch(setImportAttachment(acceptedFiles[0]));
  };

  handleYearChange = year => {
    this.props.dispatch(setImportedYear(year));
  };
  renderErrorText = code => {
    switch (code) {
      case 170020:
      case 170021:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incorrectFile")
            }}
          />
        );
      case 170070:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incompatibleModel")
            }}
          />
        );
      case 170031:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("fileSize")
            }}
          />
        );

      default:
        return <span>{_("errorOccured")}</span>;
    }
  };

  handleImportFinancial = () => {
    this.props.dispatch(importFinancialSheet()).then(
      res => {
        onSuccess(res, {
          title: _("importSuccess"),
          body: _("importFinancialSheetSuccess")
        });
        this.props.dispatch(fetchPeriodFinancialSheet());
        this.props.dispatch(setImportFinancialModal(false));
        this.props.dispatch(setImportAttachment(null));
      },
      error => {
        onError(this.renderErrorText(error.response.data.errors[0].code));
      }
    );
  };

  render() {
    const { attachment, importedYear } = this.props;
    return (
      <TTPModal
        mask={true}
        visible={this.props.isImportModalVisible}
        footer={null}
        width={650}
      >
        {this.props.isImportModalVisible ? (
          <div className="tamtam-modal upload-modal upload-modal__body">
            <ModalCloseButton onClose={this.handleCancelImportFinancial} />
            <div className="upload-modal__content">
              <DragModal>
                <div className="upload-modal__header small-12">
                  <div className="upload-modal__header-icon">
                    <SvgIcon icon={ICONS.UPLOAD} />
                  </div>
                  <div
                    className="upload-modal__header-title"
                    style={{ display: "inline-block", marginRight: "auto" }}
                  >
                    {_("importFinancialSheet")} {this.props.year}
                  </div>
                </div>
              </DragModal>
              <div className={styles.content_modal}>
                <div className={"row"}>
                  <div className={`columns medium-12 ${styles.select_label}`}>
                    selectionné l'année :
                  </div>{" "}
                  <div className={`columns medium-12 ${styles.select_span}`}>
                    <Select
                      defaultValue={importedYear.toString()}
                      style={{ width: 300 }}
                      onChange={this.handleYearChange}
                    >
                      {YEARS_VALUES.map((year, i) => {
                        return (
                          <Option value={year} key={i}>
                            {year}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className={`columns medium-12`}>
                    <div className={styles.model_description}>
                      {_("importFinancialContentModelDescription")}
                      {" : "}
                      <div style={{ fontWeight: "bold", marginTop: "1%" }}>
                        {"Client_erpId,Client_uen,Budget_" +
                          importedYear +
                          ",Budget_BE_" +
                          importedYear +
                          ",Budget_MA_" +
                          importedYear +
                          ",Budget_economique_" +
                          importedYear}
                      </div>
                    </div>
                  </div>
                  <span className={"columns medium-12"}>
                    <DocumentUploader
                      attachment={attachment}
                      handleDrop={this.handleDrop}
                      acceptedFiles=".xls,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    />
                  </span>
                  <div className={styles.modal_footer}>
                    <Button
                      type={"success"}
                      className={styles.import_btn}
                      // disabled={this.state.disabledSave}
                      disabled={!this.props.attachment}
                      loading={this.props.importFetching}
                      onClick={this.handleImportFinancial}
                    >
                      {_("import")}
                    </Button>

                    <Button
                      type={"success"}
                      className={styles.cancel_btn}
                      onClick={this.handleCancelImportFinancial}
                    >
                      {_("cancel")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </TTPModal>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  isImportModalVisible:
    state.financialSheet.importFinancialSheet.isImportModalVisible,
  attachment: state.financialSheet.importFinancialSheet.importAttachment,
  importFetching: state.financialSheet.importFinancialSheet.fetching,
  importedYear: state.financialSheet.importFinancialSheet.importedYear
});

export default connect(mapStateToProps)(ImportFinancialModal);



// WEBPACK FOOTER //
// ./src/components/Financial/ImportFinancialModal.js